function PromptIcon({ width = 20, height = 20 }) {
    return (
        <svg
            width={`${width}`}
            height={`${height}`}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_32649_7623)">
                <path
                    d="M1.25 10C1.25 12.3206 2.17187 14.5462 3.81282 16.1872C5.45376 17.8281 7.67936 18.75 10 18.75C12.3206 18.75 14.5462 17.8281 16.1872 16.1872C17.8281 14.5462 18.75 12.3206 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25C7.67936 1.25 5.45376 2.17187 3.81282 3.81282C2.17187 5.45376 1.25 7.67936 1.25 10ZM20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10ZM6.875 5.0025H10.5775C12.5562 5.0025 13.75 6.38 13.75 8.2325C13.75 10.1 12.5413 11.455 10.5625 11.455H8.48V15H6.875V5.0025ZM10.3375 10.0925C11.4538 10.0925 12.1112 9.41125 12.1112 8.2325C12.1112 7.05375 11.4538 6.38 10.3363 6.38H8.4725V10.0925H10.3375Z"
                    fill="#5D636F"
                />
            </g>
            <defs>
                <clipPath id="clip0_32649_7623">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default PromptIcon;
